module.exports = __webpack_public_path__ + "img/digitalizacion.ad7af141.svg";